import battery from './battery.png';
import bookmark from './bookmark.png';
import calender from './calender.png';
import home from './home.png';
import energy from './energy.png';
import smiley from './smiley.png';
import star from './star.png';

export default { battery, bookmark, calender, home, energy, smiley, star };
